import { Container } from './OneColumnLayout.style';
import { RootLayout } from '../RootLayout';

function OneColumnLayout({ children, ...delegated }) {
  return (
    <RootLayout>
      <Container {...delegated}>{children}</Container>
    </RootLayout>
  );
}

export default OneColumnLayout;
